import {EventStateInterface} from "@/types/EventState.interface";

export const EventStateSchema: EventStateInterface = {
    0: {
        type: 'warning',
        value: 'Черновик'
    },
    1: {
        type: 'success',
        value: 'Опубликовано'
    },
    2: {
        type: 'tertiary',
        value: 'Отменено'
    },
    3: {
        type: 'tertiary',
        value: 'Заблокировано'
    },
    4: {
        type: 'tertiary',
        value: 'Завершено'
    },
    5: {
        type: 'tertiary',
        value: 'Курс временно недоступен'
    },
    6: {
        type: 'tertiary',
        value: 'В архиве'
    },
    7: {
        type: 'tertiary',
        value: 'Завершено и скрыто'
    }
}
